/**
 * FindAccountResultContainer
 * --
 */
import React, { useState, useEffect } from 'react';
import FindAccountResultPresenter from './FindAccountResultPresenter';
import { useNavigate, useLocation } from 'react-router-dom';

const FindAccountResultContainer = (props) => {
  /* ===== ROUTE ===== */
  const location = useLocation();
  const navigate = useNavigate();

  /* ===== PROPS ===== */
  const { screenSize } = props;

  /* ===== STATE ===== */
  const [findData, setFindData] = useState({});

  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /**
   * 네비게이션 핸들러
   * --
   * @param {string} type
   */
  const handleNavigate = (type = 'signin') => {
    const isNative = window.ReactNativeWebView;

    switch (type) {
      case 'PASSWORD':
      case 'Password':
      case 'password':
        if (isNative) navigate(`/components/find/password`);
        else navigate(`/find/password`);
        break;
      case 'SIGNIN':
      case 'Signin':
      case 'SignIn':
      case 'signin':
        if (isNative) window.ReactNativeWebView.postMessage('close');
        else navigate(`/signin`);
        break;
      default:
        break;
    }
  };
  /* ===== HOOKS ===== */
  /**
   * Navigate State 값 처리
   * --
   */
  useEffect(() => {
    const resultData = location.state?.findValue;

    if (resultData) {
      const { data } = resultData;
      setFindData(data);
    }
  }, [location, navigate]);

  /* ===== RENDER ===== */
  return (
    <>
      <FindAccountResultPresenter
        navigate={navigate}
        data={findData}
        screenSize={screenSize}
        onNavigate={handleNavigate}
      />
    </>
  );
};

export default FindAccountResultContainer;
